import { Grid, IconButton } from "@mui/material";
import DatePicker, { DateObject } from "react-multi-date-picker";
import AddIcon from "@mui/icons-material/Add";
import { EditClientInvoiceRouteRateUIRequest } from "../ClientInvoiceInterfaces";
import { isDisabledDate } from "../utils/RatecardUtils";
import { SimpleValueDateRangeType } from "../../../../app/models/requestModels/ClientInvoiceEditRequest";
import store, { RootState } from "../../../../app/features/store/store";
import { useSelector } from "react-redux";

interface Props {
  values: EditClientInvoiceRouteRateUIRequest;
  field: number | undefined;
  fieldType?: string;
  date_range: DateObject[];
  date_range_values: SimpleValueDateRangeType[];
  fieldName: string;
  fieldTypeName?: string;
  fieldDateRangeName: string;
  fieldDateRangeValuesName: string;
  setFieldValue: any;
  resetValue: number;
  invoiceStartDate: Date;
  invoiceEndDate: Date;
  store: string;
  text: string;
}

export const SimpleFieldDatePicker = (props: Props) => {
  const disableFieldDateRanges = () => {
    if (
      props.values.master_date_range === undefined ||
      (props.values.master_date_range &&
        props.values.master_date_range.length < 2)
    )
      return false;
    return true;
  };
  const { isLoading, storesForCurrentClientInvoice } = useSelector(
    (state: RootState) => state.clientInvoice
  );

  const isMultiStoreEdit = (store: string): boolean => {
    return store?.split(",").map(Number).length > 1;
  };
  const resetFieldAndDateRange = (
    fieldName: string,
    dateRangeFieldName: string
  ) => {
    props.setFieldValue(fieldName, props.resetValue);
    props.setFieldValue(dateRangeFieldName, []);
  };

  const adjustedEndDate = new Date(props.invoiceEndDate);
  adjustedEndDate.setHours(23, 59, 59, 999);

  return (
    <>
      <Grid item xs={5}>
        <DatePicker
          format="MM/DD/YYYY"
          className="green"
          dateSeparator=" ~ "
          range
          rangeHover
          placeholder="Date Range"
          style={{ height: "36px", marginTop: "8px" }}
          minDate={props.invoiceStartDate}
          maxDate={adjustedEndDate}
          disabled={disableFieldDateRanges()}
          value={props.date_range}
          onChange={(value) => {
            props.setFieldValue(props.fieldDateRangeName, value);
          }}
          mapDays={({ date }) => {
            let localProps: any = {};
            // Only disable dates if it's not a multistore edit
            if (!isMultiStoreEdit(props?.store)) {
              const usedDateRanges = props.date_range_values.map((item) => {
                let startDate = item.startDate;
                let endDate = item.endDate;
                if (typeof startDate === "string")
                  startDate = new Date(startDate);
                if (typeof endDate === "string") endDate = new Date(endDate);
                return [startDate, endDate];
              });

              if (isDisabledDate(date.toDate(), usedDateRanges)) {
                localProps.disabled = true;
                localProps.style = { color: "gray", pointerEvents: "none" };
              }
            }

            return localProps;
          }}
        />
      </Grid>
      <Grid item xs={1}>
        <IconButton
          color="success"
          disabled={
            disableFieldDateRanges() ||
            props.field === undefined ||
            props.field === props.resetValue ||
            (props.date_range && props.date_range.length < 2)
          }
          sx={{ mt: 1 }}
          onClick={() => {
            if (props.field !== undefined && props.date_range.length === 2) {
              let dateRangeValues = props.date_range_values;
              const existingStoreIds =
                props?.values?.base_rate_date_range_values?.[0]?.storeIds ||
                props?.values?.variable_rate_date_range_values?.[0]?.storeIds ||
                props?.values?.route_minimum_date_range_values?.[0]?.storeIds ||
                props?.values?.late_cancellation_date_range_values?.[0]
                  ?.storeIds ||
                [];
              dateRangeValues.push({
                storeIds:
                  props?.text !== ""
                    ? props.store
                        ?.split(",")
                        .map(Number)
                        .filter((storeId) => {
                          // Collect all existing store IDs from each entry in base_rate_date_range_values

                          return existingStoreIds
                            ? !existingStoreIds.includes(storeId)
                            : true;
                        })
                        .filter(Boolean)
                    : props?.store?.split(",").map(Number),
                fieldValue: props.field,
                fieldName: props.fieldName,
                fieldType: props.fieldType,
                startDate: props.date_range[0].toDate(),
                endDate: props.date_range[1].toDate(),
              });
              props.setFieldValue(
                props.fieldDateRangeValuesName,
                dateRangeValues
              );

              resetFieldAndDateRange(props.fieldName, props.fieldDateRangeName);
            }
          }}
        >
          <AddIcon />
        </IconButton>
      </Grid>
    </>
  );
};
